/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var NProgress = require('nprogress');
var NavUtils = require('psa-core/util/nav');
var Scaffold = require('common/layout/Scaffold');

var GetEvent = require('../services/GetEvent');

var COCEventView = require('../views/COCEventView');

var GetUsersForRole = require('../../../common/services/GetUsersForRole');
var GetAllEntityLookups = require('../../common/services/GetAllEntityLookups');
var GetAllEventLookups = require('../../common/services/GetAllEventLookups');

module.exports = function(eventId) {
  $.when(GetEvent(eventId), GetAllEventLookups(), GetUsersForRole('COC - User'), GetAllEntityLookups())
    .done(function(event, eventLookups, cocUsers, entityLookups) {
      NProgress.set(0.6);
      NavUtils.navigate('coc/event/' + eventId);

      Scaffold.content.show(
        new COCEventView({
          model: new Backbone.Model({
            event: event,
            presenters: event.eventPresenters,
            organization: event.organization,
            venue: event.venue,
            eventTypes: eventLookups.eventTypes,
            programs: eventLookups.programs,
            cocUsers: cocUsers,
            aarpVolunteers: eventLookups.aarpVolunteers,
            targetAudiences: eventLookups.targetAudiences,
            eventFormats: eventLookups.eventFormats,
            entityTypes: entityLookups.entityTypes,
            organizationTypes: entityLookups.organizationTypes
          })
        })
      );
      NProgress.done();
    })
    .fail(function() {
      NProgress.done();
    });
};
